import { Chip } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';

import StoreNameLazy from '@/containers/StoreNameLazy';

const SelectedItem = ({ onDelete, value }) => (
  <Chip label={<StoreNameLazy storeId={value} />} onDelete={onDelete} />
);

SelectedItem.propTypes = {
  onDelete: PropTypes.func.isRequired,
  value: PropTypes.any.isRequired,
};

export default SelectedItem;
